import { Form, FormInstance, Radio } from "antd";
import { useMemo } from "react";
import { IOption } from "../../../../../types/Option";
import { FormButtons } from "../../IncidentReports/components/FormButtons";
import { useExport } from "../hooks/useExport";

type FormItemsProps = {
  form: FormInstance;
  closeModal: () => void;
};

export const FormItems = ({ form, closeModal }: FormItemsProps) => {
  const initialValues = useMemo(
    () => ({
      customerRole: 0,
    }),
    [],
  );

  const { isLoading, onExport } = useExport(form, closeModal);

  const options: IOption[] = useMemo(
    () => [
      {
        value: 0,
        label: "All Customers",
      },
      {
        value: 2,
        label: "Primary Sellers",
      },
      {
        value: 1,
        label: "Primary Buyers",
      },
    ],
    [],
  );

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        className="pt-6 processing-print-form"
        initialValues={initialValues}
        disabled={isLoading}
      >
        <Form.Item label="Customer Role" name="customerRole" className="mb-2">
          <Radio.Group
            options={options}
            className="w-100 d-flex flex-column small-gap"
          />
        </Form.Item>
      </Form>
      <FormButtons
        isLoading={isLoading}
        onExport={onExport}
        closeModal={closeModal}
      />
    </>
  );
};
